export const CACHE_KEY_LIST_MAIN = 'main';
export const CACHE_KEY_MAIN = 'main-one';
export const ROUTE_PATH_MAIN = '/home';
export const TRANSLATION_PREFIX_MAIN = 'main';

export const CACHE_KEY_LIST_MAIN_AUDITOR = 'auditor-main-list';
export const CACHE_KEY_MAIN_AUDITOR = 'auditor-main-one';
export const ROUTE_PATH_MAIN_AUDITOR = '/auditor-home';

export const CACHE_KEY_LIST_MAIN_CLIENT = 'client-main-list';
export const CACHE_KEY_LIST_HOME_CLIENT = 'client-home-list';
export const CACHE_KEY_AUDITS_PERCENT = 'client-main-audits-percent';
export const CACHE_KEY_REGISTERS_PERCENT = 'client-main-registers-percent';
export const CACHE_KEY_INCIDENCES_PERCENT = 'client-main-incidences-percent';
export const CACHE_KEY_MAIN_CLIENT = 'main-one';
export const ROUTE_PATH_MAIN_CLIENT = '/client-audits/resume';
export const TRANSLATION_PREFIX_CLIENT_MAIN = 'clientMain';

export const SUMMARY_MONTH_DIALOG_NAME_SPACE = 'summary-month-dialog-namespace';
export const SUMMARY_MONTH_DIALOG_ISSUE_NAME_SPACE = 'summary-month-dialog-issue_namespace';
export const AUDIT_RISK_LEVEL = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};


